// OrdersPage.js
import React from 'react';

// A simple React component that displays a heading.
const Settings = () => {
  return (
    <div>
      <h3>⚙️ Settings Page</h3>
    </div>
  );
};

export default Settings;
